import "./AgsSuite.module.css";
import Header from "@/reusable_sections/Header";
import FutureReadyInfrastructure from "./sections/FutureReadyInfrastructure";
import PortalSuccessMetrics from "./sections/PortalSuccessMetrics";
import MediaEdge from "./sections/MediaEdge";
import SaasDeliveryModels from "./sections/SaasDeliveryModels";
import TheStrategicEdge from "./sections/TheStrategicEdge";
import TheEvolutionPipeline from "./sections/TheEvolutionPipeline";
import AutomationInsights from "./sections/AutomationInsights";
import SecureYourConsultation from "./sections/SecureYourConsultation";
import Footer from "@/reusable_sections/Footer";
export default function AgsSuitePage() {
  return <div>
      <Header />
      <FutureReadyInfrastructure />
      <PortalSuccessMetrics />
      <MediaEdge />
      <SaasDeliveryModels />
      <TheStrategicEdge />
      <TheEvolutionPipeline />
      <AutomationInsights />
      <SecureYourConsultation />
      <Footer />
    </div>;
}